const AUTH_TOKEN_LOCALSTORAGE_KEY = 'jwt';

export default {
  get: () => {
    return process.env.VUE_APP_PERMANENT_JWT ||
      localStorage.getItem(AUTH_TOKEN_LOCALSTORAGE_KEY);
  },
  set: (token: string) => {
    return localStorage.setItem(AUTH_TOKEN_LOCALSTORAGE_KEY, token);
  },
  remove: () => {
    return localStorage.removeItem(AUTH_TOKEN_LOCALSTORAGE_KEY);
  },
};
